export default __webpack_public_path__ + "static/media/Online Review-cuate.378f1830.svg";